import useMutationEquipmentCreateUpdate from './equipment-use-mutation-create-update';
import useMutationEquipmentDelete from "./equipment-use-mutation-delete";
import useMutationEquipmentRemove from "./equipment-use-mutation-remove";


export const equipmentUseMutation = {
  createUpdate: useMutationEquipmentCreateUpdate,
  remove: useMutationEquipmentRemove,
  delete: useMutationEquipmentDelete,
};